import React from "react";
import { NumberField, Section, TextField } from "./fields";

const BasicsSection = ({ form, setForm, msgs, locked, tier }) => (
  <Section
    id="basics"
    title="Basics"
    description={`Tier key ${tier} cannot be changed. Terms versions that start with placeholder- cannot be sold in production.`}
  >
    <div className="row">
      <div className="col-md-6">
        <TextField
          id="warranty-displayName"
          label="Display name"
          value={form.displayName}
          maxLength={60}
          disabled={locked}
          messages={msgs("displayName")}
          onChange={(value) => setForm((prev) => ({ ...prev, displayName: value }))}
        />
      </div>
      <div className="col-md-3">
        <NumberField
          id="warranty-tierRank"
          label="Tier rank"
          kind="whole"
          value={form.tierRank}
          disabled={locked}
          help="1 is the lowest tier."
          messages={msgs("tierRank")}
          onChange={(value) => setForm((prev) => ({ ...prev, tierRank: value }))}
        />
      </div>
      <div className="col-md-12">
        <TextField
          id="warranty-termsVersion"
          label="Terms version"
          value={form.termsVersion}
          maxLength={64}
          disabled={locked}
          placeholder="for example v1.0"
          messages={msgs("termsVersion")}
          onChange={(value) => setForm((prev) => ({ ...prev, termsVersion: value }))}
        />
      </div>
    </div>
  </Section>
);

export default BasicsSection;
